var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inner",staticStyle:{"padding":"20px 0"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"normal","padding-bottom":"40px"}},[_c('img',{staticStyle:{"max-height":"100%","max-width":"100%"},attrs:{"src":_vm.pathUrl}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3511d4e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Education/indexIntro.vue
// module id = null
// module chunks = 